/**
 * @description indexedDB의 데이터베이스 이름을 관리합니다.
 */
export const DATABASE_KEY = {
  AUTH: 'auth',
} as const;

export type TypeDatabaseKey = keyof typeof DATABASE_KEY;

/**
 * @description AUTH 데이터베이스내 객체 저장소를 관리합니다.
 *
 * @remarks key 값이 변경되면 version을 올려야 됩니다.
 */
export const OBJECT_STORE_AUTH = {
  LOGIN_INFO: {
    VERSION: 1,
    STORE: 'loginInfo',
    KEY: 'id++, login_id, is_remember_id, access_token',
  },
  CHANGE_PASSWORD_INFO: {
    VERSION: 1,
    STORE: 'changePasswordInfo',
    KEY: 'id++, login_id',
  },
  TWO_FACTOR_AUTH_INFO: {
    VERSION: 1,
    STORE: 'twoFactorAuthInfo',
    KEY: 'id++, login_id, two_factor_id',
  },
} as const;

export type TypeObjectStoreAuth = keyof typeof OBJECT_STORE_AUTH;
